<img
  [ngStyle]="meinStyle"
  src="{{ grafik }}"
  (click)="holeWinkel($event)"
  (mouseover)="hebeHervor($event)"
  (mouseout)="machNormal($event)"
/>
